<template>
  <div :class="$style.wrap">
    <div
      :class="[
        $style.event,
        !data?.fields?.showOnlyInCalendar && $style.clickable,
        isActive && $style.active,
        disabled && $style.disabled,
      ]"
      :style="{
        color: data?.fields?.color,
        backgroundColor: data?.fields?.backgroundColor,
      }"
      @click="(e) => handleClick(e)"
    >
      <NuxtLink
        ref="cardLink"
        :to="
          !data?.fields?.showOnlyInCalendar
            ? `/event/${data?.fields?.pathOverride || data?.fields?.path}`
            : undefined
        "
        :class="$style.link"
        :title="data?.fields?.title || undefined"
      >
        <BasePicture
          v-for="icon in data?.fields?.icons"
          :key="icon?.sys?.id"
          :src="`${icon?.fields?.file?.url}?w=60&h=60`"
          alt=""
          :img-class="$style.icon"
          loading="eager"
        />
        <span :class="$style.title">
          {{ data?.fields?.title }}
        </span>
      </NuxtLink>
      <AddToCalendarButton v-if="!disabled" :class="$style.add" :data="data" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeEventWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data: TypeEventWithoutUnresolvableLinksResponse
  isActive?: boolean
  disabled?: boolean
}>()

const handleClick = (e: MouseEvent) => {
  const cardLinkEl = useTemplateRef<ComponentPublicInstance | null>('cardLink')
  if (cardLinkEl.value) {
    pushToGaDataLayer({
      event: 'ga4.trackEvent',
      eventName: 'event_click',
      eventParams: {
        event_name: props.data?.fields?.entryTitle,
      },
    })
    const { $handleBlockLinkClick } = useNuxtApp()
    $handleBlockLinkClick(e, cardLinkEl.value?.$el)
  }
}
</script>

<style lang="scss" module>
.wrap {
  padding: 0 3px 3px;
  height: var(--calendar-event-height);
}

.event {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 8px;
  height: 100%;
  background: var(--gray-8);
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  transition: cubic-bezier(0.16, 1, 0.29, 0.99) 0.2s;

  &.clickable {
    cursor: pointer;
  }

  @include media('sm') {
    padding: 13px;
    font-size: 14px;
    border-radius: 5px;
  }
}

.active {
  filter: brightness(110%);
}

.disabled {
  background: var(--gray-7);
}

.link {
  align-items: center;
  color: inherit;
  display: grid;
  grid-template-columns: auto 1fr;
  flex: 1 1 auto;
  gap: 5px;
  overflow: hidden;
  min-width: 0;
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.add {
  display: block;
  flex-shrink: 0;
  position: relative;
  top: 2px;
}

.icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  object-fit: contain;
  vertical-align: middle;
}
</style>
